import { Text } from '@appcues/sonar';
import { AlertBanner } from './Banners.styled';

type Props = {
  overrides?: Record<string, boolean>;
};

export default function FeatureBanner({ overrides }: Props) {
  const hasOverrides = overrides && Object.keys(overrides).length > 0;

  if (!hasOverrides) {
    return null;
  }

  return (
    <AlertBanner aria-live="polite" role="alert">
      <Text weight="bold" colorToken="white">
        ⚠️ Heads up: You are currently locally overriding feature flags
      </Text>
    </AlertBanner>
  );
}
